import React, { lazy, Suspense } from "react";
import { isEmpty } from "lodash";

import Skeleton from "~/components/loaders/Skeleton";

import { sanitizeAndParseHTML } from "~/utilities/helpers";

const ContentContainer = lazy(
    () => import("~/components/layout/ContentContainer"),
);
const SectionWrapper = lazy(() => import("~/components/layout/SectionWrapper"));
const UserContent = lazy(() => import("~/components/UserContent"));

const ProductCategoryBottomArea = ({ data }) => {
    const {
        wpProductCategory: { categoryData },
    } = data;

    if (isEmpty(categoryData?.bottomContentArea)) {
        return null;
    }

    return (
        <Suspense fallback={<Skeleton variant="block" />}>
            <SectionWrapper
                id={categoryData?.bottomContentSectionId}
                withBorder
            >
                <ContentContainer>
                    <UserContent>
                        {sanitizeAndParseHTML(categoryData.bottomContentArea)}
                    </UserContent>
                </ContentContainer>
            </SectionWrapper>
        </Suspense>
    );
};

export default ProductCategoryBottomArea;
